export default __webpack_public_path__ + "static/media/etapa3.aa200a7e.png";